import { SearchQuery } from "shared/data/reducers/types/storage";

const isDirectOnly = (maxTransfers: SearchQuery["max_transfers"]): boolean =>
  maxTransfers === "direct" || maxTransfers === 0 || maxTransfers === "0";

export default isDirectOnly;
